import { ApiRequestEnum } from 'src/app/core/enums/api-request.enum';
import { ApiService } from 'src/app/core/services/api.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class OrderService {
	constructor(
		private apiService: ApiService,
	) {
	}


	GetCustomerOrders(params: any) {

		return this.apiService.post(ApiRequestEnum.GetCustomerOrder, params);
	}

	GetDeliveryStatus(params: any) {

		return this.apiService.get(ApiRequestEnum.GetDeliveryStatus.replace('{{orderId}}', params));
	}

	GetItemOrderId(params: any) {

		return this.apiService.get(ApiRequestEnum.GetItemOrderId.replace('{{id}}', params));
	}

	CancelItemOrder(params: any) {

		return this.apiService.post(ApiRequestEnum.CancelItemOrder, params);
	}

	GetCustomerItemDocketStatus(params: any) {

		return this.apiService.get(ApiRequestEnum.GetCustomerItemDocketStatus.replace('{{docketId}}', params));

	}

	PostComment(orderId: string, params: any) {
		return this.apiService.post(
			ApiRequestEnum.ORDER_POST_COMMENT.replace('{{order_id}}', orderId),
			params
		);
	}

	OrderReview(params: any) {

		return this.apiService.post(ApiRequestEnum.ORDER_REVIEW, params);
	}


}
